module.exports = __webpack_public_path__ + "static/AD14-501dce1de704c37b6a3c6689507bce38.png";